import { z } from 'zod'

import { apiMotor } from '@/lib/api/motor'

const TractianUserSchema = z.object({
  id: z.string().optional(),
  _id: z.string().optional(),
  companyId: z.string().optional(),
  company: z
    .object({
      id: z.string().optional(),
      _id: z.string().optional()
    })
    .optional()
})

export type TractianUser = z.infer<typeof TractianUserSchema>

export async function fetchUserByEmail(email: string): Promise<TractianUser | undefined> {
  const res = await apiMotor.get(`/users/email/${encodeURIComponent(email)}`)
  const parsed = TractianUserSchema.safeParse(res.data)
  if (!parsed.success) return undefined
  return parsed.data
}

export function resolveTractianUserId(user: TractianUser | undefined) {
  return user?.id ?? user?._id
}

export function resolveTractianCompanyId(user: TractianUser | undefined) {
  return user?.companyId ?? user?.company?.id ?? user?.company?._id
}
